import React from 'react';
import Div from "@jumbo/shared/Div";
import Link from "@mui/material/Link";
import { ASSET_IMAGES } from "../../utils/constants/paths";
import { loadCompanyLogoSrc } from "../../utils/companyLogo";

const logoCache = {
    src: null,
    loaded: false,
    promise: null,
};

const Logo = ({ mini, mode, sx, logoSize }) => {
    const defaultLogo = React.useMemo(() => `${ASSET_IMAGES}/AOCLogo.webp`, [mode]);
    const [logoSrc, setLogoSrc] = React.useState(defaultLogo);
    const [logoLoaded, setLogoLoaded] = React.useState(false);

    React.useEffect(() => {
        let active = true;
        const applyLogo = (src) => {
            if (!active) return;
            setLogoSrc(src || defaultLogo);
            setLogoLoaded(true);
        };

        // Use module-level cache so toggling the sidebar doesn't refetch logos.
        if (logoCache.loaded && logoCache.src) {
            applyLogo(logoCache.src);
        } else {
            if (!logoCache.promise) {
                logoCache.promise = (async () => {
                    const src = await loadCompanyLogoSrc(defaultLogo, ['labelLogo']);
                    logoCache.src = src || defaultLogo;
                    logoCache.loaded = true;
                    return logoCache.src;
                })();
            }

            logoCache.promise
                .then(applyLogo)
                .catch(() => {
                    if (active) {
                        setLogoLoaded(true);
                    }
                });
        }

        return () => {
            active = false;
        };
    }, [defaultLogo]);

    const sizeProps = mini ? { height: 32 } : { height: 50 };
    if(logoSize){
        sizeProps.height = logoSize;
    }
    return (
        <Div sx={{ display: "inline-flex", ...sx,marginLeft:'20px' }}>
            <Link href={'/'}>
               {logoLoaded? <img src={logoSrc} alt="LOGO" {...sizeProps} />:null}
            </Link>
        </Div>
    );
};

Logo.defaultProps = {
    mode: "light"
};

export default Logo;
